import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  description:
    "A wave causes fluctuations of the medium that lead to local fluctuations of its properties. In the case of air, they involve pressure, particle velocity, density, and temperature [remove: (possibly other properties such as entropy)]. In the context of linear acoustics, the fluctuations are small compared to the mean quantities, illustrated here by the pressure fluctuations detected by a microphone. Change the scale of the vertical axes (zoom in) to see the fluctuations and check their order of magnitude.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0101/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
